import React from 'react';
import { Button, Space } from 'antd';
import { ColumnsType } from 'antd/es/table';
import ImageWithSpinner from '../content/imagewithspinner';
import { Dayjs } from 'dayjs';

export interface AddOnRecord {
    key: string;
    sortOrder: number;
    optionImageName?: string;
    displayName: string;
    menuGuid: string;
    menuOptionName: string;
    startDate: string;
    endDate: string;
    active: boolean;
}

const getColumnsSort = (
    DragHandle: React.FC<{ className?: string }>,
    handleEditAddOn: (record: AddOnRecord) => void,
    handleDeleteAddOn: (id: string) => void,
    isReadOnly: boolean
): ColumnsType<AddOnRecord> => [
        {
            key: 'sort',
            align: 'center',
            width: 80,
            render: () => <DragHandle className="drag-handle" />,
        },
        {
            key: 'sortOrder',
            title: 'Sort Order',
            dataIndex: 'sortOrder',
            render: (text: number) => <span>{text}</span>,
        },
        {
            key: 'imageName',
            title: '',
            dataIndex: 'optionImageName',
            render: (_: string, record: AddOnRecord) => (
                <div style={{ marginRight: '10px', width: '50px', height: '50px' }}>
                    {record.optionImageName && <ImageWithSpinner imageUrl={record.optionImageName} />}
                </div>
            ),
        },
        {
            key: 'displayText',
            title: 'Kiosk Text',
            dataIndex: 'displayName',
            render: (text: string,record: AddOnRecord) => <span style={{opacity: record.active ? 1 : 0.5}}>{text}</span>,
        },
        {
            key: 'addOn',
            title: 'Add-On',
            dataIndex: 'menuGuid',
            render: (_: string, record: AddOnRecord) => <span style={{opacity: record.active ? 1 : 0.5}}>{record.menuOptionName}</span>,
        },
        {
            key: "startDate",
            title: "Start Date",
            dataIndex: "startDate",
            render: (value: string, record: AddOnRecord) => <span style={{opacity: record.active ? 1 : 0.5}}>{value}</span>,
        },
        {
            key: "endDate",
            title: "End Date",
            dataIndex: "endDate",
            render: (value: string, record: AddOnRecord) => <span style={{opacity: record.active ? 1 : 0.5}}>{value}</span>,
        },
        {
            title: 'Actions',
            render: (_: any, record: AddOnRecord) => (
                <Space>
                    <Button type="link" onClick={() => handleEditAddOn(record)}>Edit</Button>
                    {!isReadOnly && (
                        <Button type="link" onClick={() => handleDeleteAddOn(record.key)}>Delete</Button>
                    )}
                </Space>
            ),
        },
    ];

export default getColumnsSort;